import useTranslation from "@/hooks/useTranslation";
import { withAuth } from "./auth0-service";

const API_URL = import.meta.env.VITE_API_BASE_URL || "https://localhost:7122/api";

export const dashboardApi = {
  users: {
    getUsers: async (days) => {
      const options = await withAuth();
      const response = await fetch(
        `${API_URL}/Dashboard/user-counts?days=${days}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Dashboard_Error_New_Users");
      }
      return response.json();
    },
    getUsersByAgent: async (days) => {
      const options = await withAuth();
      const response = await fetch(
        `${API_URL}/Dashboard/most-used-agent-by-users?days=${days}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch most used agent by users");
      }
      return response.json();
    },
  },
  support: {
    submitRequest: async ({ email, message }) => {
      const options = await withAuth({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ "emailFrom": email, "message": message }),
      });

      const response = await fetch(`${API_URL}/Dashboard/support`, options);

      if (!response.ok) {
        let errorMessage = "Failed to submit support request";
        try {
          const errorBody = await response.json();
          if (errorBody?.message) {
            errorMessage = errorBody.message;
          }
        } catch (error) {
          const fallbackText = await response.text();
          if (fallbackText) {
            errorMessage = fallbackText;
          }
        }

        throw new Error(errorMessage);
      }

      try {
        return await response.json();
      } catch (error) {
        return {};
      }
    },
  },
  messages: {
    getMessagesCount: async (days) => {
      const options = await withAuth();
      const response = await fetch(
        `${API_URL}/Dashboard/daily-message-counts?days=${days}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(
          error || "Failed to fetch messages distribution by most used agent"
        );
      }
      return response.json();
    },
    getMostUsedAgentByMessages: async (days) => {
      const options = await withAuth();
      const response = await fetch(
        `${API_URL}/Dashboard/agent-message-stats?days=${days}`,
        options
      );
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || "Failed to fetch messages");
      }
      return response.json();
    },
  },
};
